import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bs-modal"
export default class extends Controller {
  connect() {
    this.modal = new bootstrap.Modal(this.element, { backdrop: 'static', keyboard: true })
    this.handleEscape = this.handleEscape.bind(this)
    this.handleShown = this.handleShown.bind(this)
    this.handleHidden = this.handleHidden.bind(this)

    this.element.addEventListener('shown.bs.modal', this.handleShown)
    this.element.addEventListener('hidden.bs.modal', this.handleHidden)
    document.addEventListener('keydown', this.handleEscape, true)
    this.modal.show()
  }

  disconnect() {
    document.removeEventListener('keydown', this.handleEscape, true)
    this.element.removeEventListener('shown.bs.modal', this.handleShown)
    this.element.removeEventListener('hidden.bs.modal', this.handleHidden)
    this.modal.hide()
  }

  dismiss(e) {
    if (e.detail.success) this.modal.hide();
  }

  handleEscape(event) {
    if (event.key !== 'Escape') return

    const openModals = Array.from(document.querySelectorAll('.modal.show'))
    const topModal = openModals
      .sort((a, b) => {
        const aZIndex = parseInt(window.getComputedStyle(a).zIndex, 10) || 0
        const bZIndex = parseInt(window.getComputedStyle(b).zIndex, 10) || 0
        return aZIndex - bZIndex
      })
      .pop()

    if (topModal !== this.element) return

    event.preventDefault()
    event.stopPropagation()
    this.modal.hide()
  }

  handleShown() {
    const visibleModals = Array.from(document.querySelectorAll('.modal.show'))
    const modalLevel = visibleModals.length
    const zIndex = 1040 + modalLevel * 10
    this.element.style.zIndex = zIndex

    setTimeout(() => {
      const backdrops = Array.from(document.querySelectorAll('.modal-backdrop:not(.modal-stack)'))
      const backdrop = backdrops.pop()
      if (!backdrop) return

      backdrop.style.zIndex = zIndex - 1
      backdrop.classList.add('modal-stack')
    }, 0)
  }

  handleHidden() {
    if (document.querySelector('.modal.show')) {
      document.body.classList.add('modal-open')
    }
  }
}
